"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = [{
  id: 1,
  title: "Aesthetics",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/eyebrow_tattooing_service.png"
}, {
  id: 2,
  title: "Skin Revitalisation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/lip_tattooing_service.png"
}, {
  id: 3,
  title: "Clinical Beauty",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/beauty_services_procell.png"
}, {
  id: 4,
  title: "Wellness Massage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/makeup_services_glam.png"
}];
const services = [{
  categoryId: 1,
  name: "Lip Fillers",
  path: "/AestheticsPage"
}, {
  categoryId: 1,
  name: "Botox",
  path: "/AestheticsPage"
}, {
  categoryId: 1,
  name: "MicroNeedling",
  path: "/AestheticsPage"
}, {
  categoryId: 1,
  name: "Chemical Peel",
  path: "/AestheticsPage"
}, {
  categoryId: 2,
  name: "Advanced Facial",
  path: "/AestheticsPage"
}, {
  categoryId: 2,
  name: "OxyGen Facial",
  path: "/AestheticsPage"
}, {
  categoryId: 2,
  name: "Skin Boosters",
  path: "/AestheticsPage"
}, {
  categoryId: 2,
  name: "Vitamin Therapy",
  path: "/AestheticsPage"
}, {
  categoryId: 3,
  name: "Microneedling",
  path: "/BeautyPage"
}, {
  categoryId: 3,
  name: "Chemical Peels",
  path: "/BeautyPage"
}, {
  categoryId: 3,
  name: "Dermaplaning",
  path: "/BeautyPage"
}, {
  categoryId: 4,
  name: "Deep Tissue Release",
  path: "/MassagePage"
}, {
  categoryId: 4,
  name: "Swedish Relaxation",
  path: "/MassagePage"
}];
export default function OurSignatureExpertise() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="134289" id="precision-treatments" className="bg-background py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-foreground tracking-widest italic">
            Precision Treatments
          </h2>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16">
          {categories.map((category, index) => {
          const categoryServices = services.filter(s => s.categoryId === category.id);
          return <div key={category.id} data-index={index} className={`group flex flex-col items-center text-center transition-all duration-700 ease-out delay-[${index * 100}ms] ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <div className="mb-8 overflow-hidden rounded-full shadow-[0_10px_40px_rgba(0,0,0,0.02)] p-1 bg-background border border-border">
                  <img src={category.image} alt={category.title} className="w-32 h-32 rounded-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                </div>

                <h3 className="text-xl font-bold font-serif text-foreground mb-6 tracking-wide">
                  {category.title}
                </h3>

                <ul className="flex flex-col gap-3 items-center w-full">
                  {categoryServices.map((service, sIndex) => <li key={service.name} data-index={sIndex}>
                      <Link to={service.path} className="group/link relative inline-block font-sans text-foreground/80 text-base transition-colors hover:text-foreground">
                        {service.name}
                        <span className="absolute -bottom-1 left-0 w-full h-[1px] bg-accent origin-left scale-x-0 transition-transform duration-500 ease-out group-hover/link:scale-x-100" />
                      </Link>
                    </li>)}
                </ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
}